export default __webpack_public_path__ + "static/media/home.776f3e5e.png";